// World/Tile coordinate conversions. WCoord/TCoord are signed 16-bit (mpshared/mpht.h:29-30);
// 1 tile = 256 world units. game/ht.h:778-841.

import { s16 } from './int32.ts';

// game/ht.h:778-780 `return wc >> 8` — arithmetic shift on the signed short
export const TcFromWc = (wc: number): number => s16(wc) >> 8;

// game/ht.h:827-829 `return tc << 8` — stored back to WCoord (short truncation)
export const WcFromTc = (tc: number): number => s16(tc << 8);

// game/ht.h:835-837 `return wc & 0xff00` — int-promoted mask, truncated to short on return
export const WcTrunc = (wc: number): number => s16(s16(wc) & 0xff00);

// game/ht.h:839-841 `return wc & 0x00ff`
export const WcFrac = (wc: number): number => s16(wc) & 0x00ff;

// game/ht.h:1017 `const int kcmsUpdate = 80` — 80ms per Update (the lockstep tick)
export const kcmsUpdate = 80;

// game/ht.h:813-816 — pixel -> world at the ART scale (gmpWcFromPc; for 32px-tile 832 art
// the table is exactly pc*256/32). The art scale is fixed per pack: identical on all
// clients, so this is sim-deterministic. ht.h:797 WcFromPc32 is the same formula.
export function WcFromUpc(pc: number, gcxTile: number = 32): number {
  return ((pc * 256) / gcxTile) | 0;
}

// game/ht.h:797 — WcFromPc32(pc) = pc*256/32 (FIXED /32 regardless of art scale)
export function WcFromPc32(pc: number): number {
  return ((pc * 256) / 32) | 0;
}

// game/ht.h:823-826 TcFromUpc = TcFromWc(WcFromUpc(pc))
export function TcFromUpc(pc: number, gcxTile: number = 32): number {
  return TcFromWc(WcFromUpc(pc, gcxTile));
}

// game/ht.h WcFromTile16ths(n) = n * (kwcTile/16)
export function WcFromTile16ths(n: number): number {
  return n * 16;
}
